<template>
    <div class="modal">
        <div class="login">
            <div class="head">
                <span class="title">用戶登錄</span>
                <div class="close" @click="onClose">
                    <a-icon type="close" style="color: #fff;" />
                </div>
            </div>
            <div class="login-form">
                <div class="logos">
                    <img :src="association.logourl" alt="">
                    <img src="../../assets/imgs/img_logo.png" alt="">
                </div>
                <div class="form-item head">
                    <span>服務由</span>
                    <a href="http://www.ectcm.com" target="_blank">中醫在綫</a>
                    <span>提供，學會會員和中醫在綫網通用。</span>
                </div>
                <div class="form-item">
                    <span class="hint">用戶名:</span>
                    <input type="tel" class="value" placeholder="请输入手機號" v-model="phone">
                </div>
                <div class="form-item">
                    <span class="hint">密　碼:</span>
                    <input type="password" class="value" placeholder="请输入登錄密碼" v-model="password">
                </div>
                <div class="options">
                    <button class="btn-login" @click="login">登錄</button>
                    <!-- <a href="javascript:;" @click="register">註冊</a> -->
                    <a href="javascript:;" @click="forgetPwd">忘記密碼?</a>
                </div>
                <loading v-if="loading" />
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from '../Loading.vue'
    export default {
        components: { Loading },
        props: {
            callback: Function,
        },
        data(){
            return {
                loading: false,
                phone: null,
                password: null,
                association: this.$store.getters.association,
            }
        },
        mounted: function(){
        },
        methods: {
            onClose: function(){
                this.callback && this.callback()
            },
            register: function(){
                this.callback && this.callback('register')
            },
            forgetPwd: function(){
                this.callback && this.callback('forgetPwd')
            },
            login: function(){
                if(!this.phone) {
                    this.$message.warning('請輸入手機號')
                    return
                }

                if(!/^1[3-9]{1}[0-9]{9}$/.test(this.phone.trim()) && !/^([5|6|8|9])\d{7}$/.test(this.phone.trim())) {
                    this.$message.warning('請輸入正確的手機號')
                    return
                }

                if(!this.password || !this.password.trim()) {
                    this.$message.warning('請輸入登錄密碼')
                    return
                }

                this.loading = true
                this.$store.dispatch('login', {
                    loginName: this.phone,
                    password: this.password
                }).then((data) => {
                    this.loading = false
                    this.callback && this.callback('loginSuccess', data)
                }).catch((error) => {
					this.loading = false
					this.$message.warning(error || '登錄失敗, 請稍後重試！')
                })
                
            }
        },
        created: function(){
            setTimeout(() => {
                document.body.style="overflow: hidden;"
            }, 50)
        },
        destroyed: function(){
          document.body.style="overflow: unset;"
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed;
        background-color: #73737347;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 99;
    }

    .login {
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 50, 0, .4);
        -moz-transition: -moz-box-shadow linear .2s;
        -webkit-transition: -webkit-box-shadow linear .2s;
        transition: -webkit-box-shadow linear .2s;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 400px;
        height: 400px;
        background-color: #fff;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
    }

    .login > .head {
        height: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-image: linear-gradient(235deg,#7cc661,#3f9528);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 12px;
    }

    .login > .head > .title {
        height: 29px;
        line-height: 29px;
        padding: 0 25px 0 0;
        text-indent: 5px;
        color: #FFF;
        font-size: 16px;
        font-weight: 700;
        text-shadow: -1px -1px 0 rgba(0, 50, 0, .7);
    }

    .login > .head > .close {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .login > .login-form {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0px 24px;
        position: relative;
    }

    .login > .login-form > .logos {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin: 12px 0;
    }

    .login > .login-form > .logos > img {
        width: 180px;
        height: 30px;
        object-fit: contain;
        border: 1px solid #f7f7f7;
    }

    .login > .login-form > .form-item {
        display: flex;
        flex-direction: row;
        height: 33px;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 16px;
        color: #232323;
        font-weight: 400;
        font-size: 14px;
    }

    .login > .login-form > .form-item > a {
        color: #3f9528;
        text-decoration: underline;
    }

    .login > .login-form > .form-item > input {
        display: block;
        flex: 1;
        height: 33px;
        line-height: 33px;
        border: 1px solid #e8e8e8;
        border-radius: 2px;
        padding: 0 8px;
        margin-left: 12px;
    }

    .login > .login-form > .options {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 40px;
        align-items: center;
    }

    .login > .login-form > .options > .btn-login {
        height: 33px;
        line-height: 33px;
        padding: 0 12px;
        color: #fff;
        border-radius: 8px;
        background-color: #3f9528;
        border: 1px solid #ddd;
        box-shadow: 1px 1px 5px #eee;
    }

    .login > .login-form > .options > .btn-login:active {
        opacity: 0.7;
    }

    .login > .login-form > .options > a {
        color:#3f9528;
        text-decoration: underline;
        margin-left: 40px;
    }

    @media only screen and (max-width: 1050px) {
        .login {
            width: 95%;
        }

        .login > .login-form > .form-item.head {
            height: unset;
            display: block;
        }
    }
</style>
